export let ResetStateActionType;
(function (ResetStateActionType) {
  ResetStateActionType["ResetState"] = "RESET_STATE";
})(ResetStateActionType || (ResetStateActionType = {}));